var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Button, HorizontalButtonsSwitcher } from "components/button";
import { CommonModal } from "components/common_modal";
import { SearchBox } from "components/searchbox";
import { t } from "i18next";
import * as React from 'react';
import { useTranslation } from "react-i18next";
import { Badge } from "tiers/badge";
import { TierContext } from "tiers/context";
import { callApi } from "../api/api";
import { toPercent } from "../view/formatters";
import { DiagramFile } from "./diagram";
const DIAGRAMS_PER_PAGE = 12;
const UNLIMITED_TIER_DIAGRAM_LIMIT = 1000000;
/** "About Chemix" modal dialog. */
export const FileOpenModal = (_a) => {
    var { auth } = _a, modalState = __rest(_a, ["auth"]);
    const [isLoading, setIsLoading] = React.useState(false);
    const { t } = useTranslation();
    return React.createElement(CommonModal, Object.assign({}, modalState, { extraClass: "cloud-browse-modal", title: t("cloud.modal_title"), icon: isLoading ? "loading" : "fa-cloud", iconSwapOpacity: true }), auth.state === "logged_in" ? React.createElement(ShowFiles, { auth: auth, close: () => modalState.setIsOpen(false), isLoading: setIsLoading }) : null);
};
class FilterSwitcher extends HorizontalButtonsSwitcher {
}
class ShowFiles extends React.Component {
    constructor(props) {
        super(props);
        this.isLoading = () => this.state.currentFetchToken !== undefined;
        this.onOpen = (diagramId) => {
            this.props.close();
            // Invoke the API to mark the diagram as opened.
            callApi("diagram/opened", "POST", this.props.auth, { id: diagramId }, {
                success: () => { },
                generic: () => { }
            });
        };
        this.state = { diagrams: [], page: 0, totalPages: 0, search: "", filter: "all" };
    }
    componentDidMount() {
        this.fetch({ page: 1 });
        this.setState({ page: 1, search: "", filter: "all" });
    }
    render() {
        var _a, _b;
        let now = new Date();
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: "row mb-2 align-items-center " + (((_a = this.state.usage) === null || _a === void 0 ? void 0 : _a.total) === 0 && this.state.diagrams.length === 0 && !this.state.search && this.state.filter === "all" ? "d-none" : "") },
                React.createElement("div", { className: "col-12 col-md-6 col-lg-5" },
                    React.createElement(SearchBox, { value: this.state.search, onChange: value => this.setState({ search: value, page: 1 }, () => this.fetch({ page: 1 })), placeholder: t("cloud.search"), throttleMs: 500 })),
                React.createElement("div", { className: "col-12 col-md-6 col-lg-7 mt-2 mt-md-0 d-flex justify-content-start justify-content-md-end" },
                    React.createElement(FilterSwitcher, { className: "prominent", onSwitch: value => this.setState({ filter: value, page: 1 }, () => this.fetch({ page: 1 })), defaultValue: this.state.filter, extraClass: "narrower", options: [
                            { value: "all", buttonLabel: t("cloud.filter_all") },
                            { value: "mine", buttonLabel: t("cloud.filter_mine") },
                            { value: "shared_with_me", buttonLabel: t("cloud.filter_shared") }
                        ] }))),
            (((_b = this.state.usage) === null || _b === void 0 ? void 0 : _b.total) === 0 && this.state.diagrams.length === 0 && this.state.filter === "all" && !this.state.search) ?
                React.createElement("p", null, "You don't have any diagrams stored in the cloud yet.")
                : this.state.diagrams.length === 0 && !this.isLoading() ?
                    React.createElement("p", null, this.state.search ? `No diagrams matching "${this.state.search}"` : "No diagrams found.")
                    : undefined,
            React.createElement("div", { className: "row no-gutters file-grid " + (this.isLoading() ? "loading" : "") }, this.state.diagrams.map(d => React.createElement(DiagramFile, { key: `${d.created}`, now: now, diagram: d, 
                // TODO: Fetch correct page after deletion/rename
                onDelete: () => this.fetch({ page: this.state.page }), onRename: () => { this.setState({ page: 1 }); this.fetch({ page: 1 }); }, onOpen: this.onOpen }))),
            (this.state.usage && this.state.usage.limit != UNLIMITED_TIER_DIAGRAM_LIMIT) ?
                React.createElement(UsageMeter, { limit: this.state.usage.limit, total: this.state.usage.total })
                : undefined,
            this.state.totalPages > 1 ?
                React.createElement("div", { className: "text-center" },
                    React.createElement(Pager, { currentPage: this.state.page, totalPages: this.state.totalPages, onSelectPage: (page) => this.fetch({ page }) }))
                : undefined);
    }
    setCurrentFetchToken(token) {
        if (token !== undefined) {
            this.setState({ currentFetchToken: token });
            this.props.isLoading(true);
        }
        else {
            this.setState({ currentFetchToken: undefined });
            this.props.isLoading(false);
        }
    }
    fetch(options) {
        const { page } = options;
        const search = this.state.search;
        const filter = this.state.filter;
        // Generate a fetch token.
        const fetchToken = (Math.random() * 10000).round();
        this.setCurrentFetchToken(fetchToken);
        let request = {
            pageSize: DIAGRAMS_PER_PAGE,
            page: page - 1,
            search,
            filter,
        };
        callApi("diagrams", "GET", this.props.auth, request, {
            success: response => {
                if (this.state.currentFetchToken != fetchToken)
                    return;
                const diagrams = response.diagrams.map(d => ({
                    id: d.id,
                    title: d.title,
                    thumbnail: d.thumbnailBase64,
                    rawData: d.data,
                    created: new Date(d.created),
                    modified: new Date(d.modified),
                    owner: d.owner,
                    sharedWith: d.sharedWith,
                }));
                this.setState({
                    diagrams: diagrams,
                    page: response.page + 1,
                    totalPages: response.totalPages,
                    usage: response.usage,
                });
                // Only reset the fetch token if the tokens matched.
                this.setCurrentFetchToken();
            },
        });
    }
}
const Pager = (props) => {
    var buttons = [];
    for (var i = 1; i <= props.totalPages; i++) {
        if (props.currentPage == i) {
            buttons.push(React.createElement(Button, { key: `page_${i}`, extraClass: "narrower highlight", buttonLabel: i.toString(), onClick: () => { } }));
        }
        else {
            const page = i;
            buttons.push(React.createElement(Button, { key: `page_${i}`, extraClass: "narrower", buttonLabel: i.toString(), onClick: () => props.onSelectPage(page) }));
        }
    }
    return React.createElement("div", { className: "horizontal-button-group" }, buttons);
};
const UsageMeter = (props) => {
    const { t } = useTranslation();
    const percent = toPercent(Math.min(props.limit, props.total) / props.limit);
    let color = "secondary";
    let barColor = "info";
    let textClass = "";
    if (props.total >= props.limit) {
        color = "danger";
        textClass = "text-danger";
        barColor = "danger";
    }
    return React.createElement("div", { className: `border border-${color} rounded text-left p-2`, style: { maxWidth: 220 } },
        React.createElement("div", { className: textClass },
            t('cloud.diagrams_used'),
            ": ",
            props.total,
            " / ",
            props.limit),
        React.createElement("div", { className: `progress bg-secondary`, style: { height: 8 } },
            React.createElement("div", { className: `progress-bar bg-${barColor}`, role: "progressbar", style: { width: percent } })),
        React.createElement(MaybeUpgradeButton, null));
};
const MaybeUpgradeButton = () => {
    return React.createElement(TierContext.Consumer, null, tiers => (!tiers.tier
        ? React.createElement(React.Fragment, null,
            "Need more storage? ",
            React.createElement("div", { className: "ui-button", onClick: () => tiers.popup('cloud') },
                "Upgrade ",
                React.createElement(Badge, { tier: "boost" })))
        : null));
};
